
import {from as observableFrom,  of ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/data-persistence';
import { map ,  switchMap ,  mapTo } from 'rxjs/operators';

import { toDashedFromCamelCase } from '../../../../../helpers/';
import { BITBUCKET_ASSOCIATED_REPOSITORY, BITBUCKET_PULL_REQUEST_PL } from '../../../../constants/';
import { GetCompleteAction, NoopAction, UndoAction } from '../../../../ngrx/actions/root.action';
import { AppState, getEmptyESState } from '../../../../ngrx/state/';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import * as bitbucketPullRequest from './bitbucket-pull-request.actions';
import { PaywallService } from '../../../../libs/paywall/paywall.service';
import { Features } from '../../../../libs/paywall/features.constants';

@Injectable()
export class BitbucketPullRequestEffects {
  private key = toDashedFromCamelCase(BITBUCKET_PULL_REQUEST_PL);

  readonly defaultErrorHandler = <T>(action, error) => {
    console.error('effect', action, error);
  };

  @Effect()
  getByTaskMock$ = this._paywall.isFeatureEnabled(Features.Bitbucket)
    ? this.d.fetch<bitbucketPullRequest.GetTaskPullRequest>(bitbucketPullRequest.GET_TASK_PULL_REQUEST, {
        run: (action, store) =>
          this.api.get([this.key], { ...action.payload, expand: [BITBUCKET_ASSOCIATED_REPOSITORY] }).pipe(
            map(jsonApiToEntityState),
            switchMap(state => {
              const actions = [
                new GetCompleteAction(state),
                new bitbucketPullRequest.GetTaskPullRequestComplete({
                  taskId: action.payload.task,
                  entities: state[BITBUCKET_PULL_REQUEST_PL] || getEmptyESState()
                })
              ];
              return of(...actions);
            })
          ),
        onError: (action, error) => {
          this.defaultErrorHandler(action, error);
          return new bitbucketPullRequest.GetTaskPullRequestFail();
        }
      })
    : observableFrom([]);

  @Effect()
  remove$ = this._paywall.isFeatureEnabled(Features.Bitbucket)
    ? this.d.optimisticUpdate(bitbucketPullRequest.DELETE_TASK_PULL_REQUEST, {
        run: (action: bitbucketPullRequest.DeleteTaskPullRequest, store) =>
          this.api.deleteRequest([this.key, action.payload.id]).pipe(mapTo(new NoopAction())),
        undoAction: (action, error) => {
          console.log('handle error!', error);
          return new UndoAction(action);
        }
      })
    : observableFrom([]);

  constructor(private api: AtlazApiV2Service, private d: DataPersistence<AppState>, private _paywall: PaywallService) {}
}
